import React from "react";
import { recordEvent } from "../components/Analytics";
import { navigate } from "../components/Router";
import { useSessionContext } from "../components/Session";
import { isBrowser } from "../components/Browser";
import Footer from "./Footer";
import MobileFooter from "./MobileFooter";
import Navbar from "containers/Navbar";

import log from "loglevel";

// import "../sass/app.scss";
import "../sass/common.scss";
import { LoadingText } from "./admin/LoadingText";

const LoadingPage = (props) => (
  <div className="global-wrapper">
    <Navbar {...props} />
    <main>
      <LoadingText />
    </main>
    <Footer />
    <MobileFooter />
  </div>
);

const Layout = (props) => {
  const {
    data,
    location: { pathname, search, hash },
  } = props;
  const { pageContext } = props;
  const baseData = data ? data : pageContext;
  const { children, isAdminPage, requireLoggedIn } = props;
  const { sessionContext } = useSessionContext();
  const { isLoggedIn, isAdminUser } = sessionContext;
  const { email } = sessionContext.userInfo || {};

  log.debug("Layout::render() props:", props);
  log.debug("Layout::isAdminPage:", isAdminPage);
  log.debug(`Layout:: isLoggedIn:${isLoggedIn} ${isAdminUser}`);

  if (!isLoggedIn && (isAdminPage || requireLoggedIn)) {
    if (isBrowser()) {
      log.debug("Layout:: Not logged in, must be logged in.");
      const next = encodeURI(`${pathname}${search}${hash}`);
      navigate(`/login#${next}`);
    }
    // This runs in Node.js, when Gatsby is generating the assets on the server-side
    // We do this to prevent users who are not logged in from seeing a flash of the page
    // which they aren't supposed to see.
    return <LoadingPage {...props} />;
  }

  if (isLoggedIn && isAdminPage && !isAdminUser) {
    log.error(`Layout:: You don't have permission to view ${pathname}`);
    recordEvent({ name: "NotAuthorized", pathname, email });
    navigate(`/`);
    return <LoadingPage {...props} />;
  }

  return (
    <div className="global-wrapper">
      <Navbar {...props} />
      <main>{children}</main>
      <Footer />
      <MobileFooter />
    </div>
  );
};

export default Layout;
